import { render, staticRenderFns } from "./updateMajor.vue?vue&type=template&id=07bd7d16&scoped=true"
import script from "./updateMajor.vue?vue&type=script&lang=js"
export * from "./updateMajor.vue?vue&type=script&lang=js"
import style0 from "./updateMajor.vue?vue&type=style&index=0&id=07bd7d16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bd7d16",
  null
  
)

export default component.exports